<template>
  <div class="search_layout box_wrap">
    <div class="search_box">
      <select-year v-model="param.year"></select-year>
      <select-semester v-model="param.semester"></select-semester>
      <select-course ref="select-course" v-model="param.course" :year="param.year" :semester="param.semester" @loaded="loadedCourse"></select-course>

      <div class="search_btn" @click="doSearch">{{ $i18n.translate('검색') }}</div>
    </div>

    <div class="card box_wrap mt-3" v-if="isTotalData">
      <div class="customChart_label_wrap justify-content-end">
        <div class="label_item" v-for="(data, index) in legendTotals" :key="index">
          <div class="label" :style="data.style"></div>
          <div class="text">{{ data.label }}</div>
        </div>
      </div>
      <div class="card_grid mt-3">
        <card-summary v-for="(item, index) in totalData"
                      :label="item.studyItem"
                      :total="item.total"
                      :done="item.done"
                      :todo="item.todo"
                      :key="index">
        </card-summary>
      </div>
    </div>

    <div class="card box_wrap" v-if="isTotalChartData">
      <card-title :title="titles.total.title"></card-title>

      <div class="customChart_label_wrap justify-content-end">
        <div class="label_item" v-for="(data, index) in legendTotals" :key="index">
          <div class="label" :style="data.style"></div>
          <div class="text">{{ data.label }}</div>
        </div>
      </div>
      <stack-chart v-for="(data, index) in totalChartData" :chart-data="data" :key="index" :height="70"></stack-chart>
    </div>

    <div class="card" id="partiChart" v-if="isPartiChartData">
      <card-title :title="titles.parti.title"></card-title>

      <div class="customChart_label_wrap justify-content-end">
        <div class="label_item" v-for="(data, index) in legendPartis" :key="index">
          <div class="label" :style="data.style"></div>
          <div class="text">{{ data.label }}</div>
        </div>
      </div>
      <line-chart v-for="(data, index) in partiChartData" :chart-data="data" :key="index" :height=200></line-chart>
    </div>

    <div class="card" v-if="isTimeChartData">
      <card-title :title="titles.time.title"></card-title>

      <div class="customChart_label_wrap justify-content-end">
        <div class="label_item" v-for="(data, index) in legendTimes" :key="index">
          <div class="label" :style="data.style"></div>
          <div class="text">{{ data.label }}</div>
        </div>
      </div>
      <line-chart v-for="(data, index) in timeChartData" :chart-data="data" :key="index" :height=200></line-chart>
    </div>

  </div>

</template>

<script>
import SelectYear from '@/components/input/SelectYear';
import SelectSemester from '@/components/input/SelectSemester';
import SelectCourse from '@/components/input/SelectCourse';
import CardTitle from '@/components/layout/CardTitle.vue';
import CardSummary from '@/components/chart/CardSummary.vue';
import StackChart from '@/components/chart/StackChart';
import LineChart from '@/components/chart/LineChart';
import Mixin from '@/common/mixin';
import UT from "@/common/util";
import { STUDY_ITEMS, SEMESTERS } from "@/common/define";

export default {
  name: "StatusSemester",
  components: {
    SelectYear,
    SelectSemester,
    SelectCourse,
    CardTitle,
    CardSummary,
    StackChart,
    LineChart
  },
  mixins: [Mixin],
  data: () => ({
    param: {
      year: "",
      semester: '',
      course: {}
    },
    totalData: [],
    totalChartData: [],
    partiChartData: [],
    timeChartData: [],
    legendTotals: [],
    legendPartis: [],
    legendTimes: [],
    titles: {
      total: {
        title: '종합활동현황',
      },
      parti: {
        title: '주차별활동참여율',
      },
      time: {
        title: '주차별활동시간',
      }
    }
  }),
  computed: {
    isSelectedCourse() {
      return !UT.isEmpty(this.param.course.course_id);
    },
    isTotalData() {
      return this.totalData.length > 0 && this.isSelectedCourse;
    },
    isTotalChartData() {
      return this.totalChartData.length > 0 && this.isSelectedCourse;
    },
    isPartiChartData() {
      return this.partiChartData.length > 0 && this.isSelectedCourse;
    },
    isTimeChartData() {
      return this.timeChartData.length > 0 && this.isSelectedCourse;
    },
    styleBackColorDone() {
      return `background-color:${this.dataColor(0)}`;
    },
    styleBackColorTodo() {
      return `background-color:${this.dataColor(1)}`;
    }
  },
  beforeMount() {
    let now = new Date();
    this.param.year = this.$session.get("year") || `${now.getFullYear()}`;
    this.param.semester = this.$session.get("semester") || '10';
  },
  methods: {
    dataReset() {
      this.totalData = [];
      this.totalChartData = [];
      this.partiChartData = [];
      this.timeChartData = [];
      this.legendPartis = [];
      this.legendTimes = [];
    },
    loadedCourse() {
      if (!this.$session.get("loaded-done")
        && this.param.year === this.$session.get("year")
        && this.param.semester === this.$session.get("semester")
      ) {
        this.$refs["select-course"].selectCourse(this.$session.get("course_id"), () => {
          this.doSearch();
          this.$session.set("loaded-done", true);
        });
      }
    },
    doScrollTarget() {
      this.$refs["scrollTarget"].scrollIntoView({ behavior: "smooth" })
    },
    doSearch() {
      if (UT.isEmpty(this.param.course.course_id)) {
        UT.alert(this, this.$i18n.translate('교과목을선택하세요'))
        return;
      }
      let req = {
        url: '/api/chart/progress/course',
        data: {
          course_id: this.param.course.course_id,
          user_id: this.$session.get("user_id"),
          type: 'semester'
        }
      };
      this.dataReset();
      UT.api(req).then((res) => {
        if (res.data && res.data.result) {
          let data = res.data.result;
          if (data) {
            this.setTotalData(data);
          }
        }
      });
    },
    setTotalData(data) {
      if (data) {
        this.totalData = [];
        Object.keys(STUDY_ITEMS).forEach((key) => {
          if (data[key] && data[key].total) {
            let ysLabels = Object.keys(data[key]).filter((row) => {
              return row !== 'total' && row !== 'avg';
            }).map((row) => {
              let v = row.split('-');
              return this.$i18n.translate(`{0}년도{1}`, v[0], SEMESTERS[v[1]]);
            });
            let total = {
              studyItem: key,
              ysLabels: ysLabels
            };

            Object.entries(data[key].total).forEach((row) => {
              total[row[0]] = row[1];
            });
            this.totalData.push(total);
          } else {
            this.totalData.push({
              studyItem: key,
              total: 0,
              done: 0
            });
          }
        });
        this.sortData(this.totalData);
        this.setChartData(data);
      }
    },
    setChartData(data) {
      this.totalChartData = [];
      this.partiChartData = [];
      this.timeChartData = [];

      if (data) {
        let lastWeek = 0;
        Object.entries(data).forEach((studyItem) => {
          Object.keys(studyItem[1]).forEach((ys) => {
            if (ys !== 'total' && ys !== 'avg') {
              let ysData = studyItem[1][ys];
              Object.keys(ysData).forEach((w) => {
                if (!isNaN(w)) {
                  lastWeek = Math.max(lastWeek, parseInt(w, 10));
                }
              });
            }
          });
        });

        let weekLabels = [];
        let dataPartis = {};
        let dataTimes = {};
        let dataPartiAvgs = {};
        let dataTimeAvgs = {};
        let dataTotals = {};
        for (let week = 1; week <= lastWeek; week++) {
          let studyItemKeys = Object.keys(data);
          weekLabels.push(this.$i18n.translate(`{0}주차`, week));
          if (week === 1) {
            studyItemKeys.forEach((studyItem) => {
              dataPartis[studyItem] = {};
              if (studyItem === "vod") {
                dataTimes[studyItem] = {};
              }
              dataPartiAvgs[studyItem] = [];
              dataTimeAvgs[studyItem] = [];
              dataTotals[studyItem] = {};

              Object.keys(data[studyItem]).forEach((ys) => {
                if (ys !== 'total' && ys !== 'avg') {
                  dataPartis[studyItem][ys] = [];
                  if (studyItem === "vod") {
                    dataTimes[studyItem][ys] = [];
                  }
                  dataTotals[studyItem][ys] = {
                    done: 0,
                    todo: 0,
                    total: 0,
                  };
                }
              });
            });
          }
          studyItemKeys.forEach((studyItem) => {
            Object.keys(data[studyItem]).forEach((ys) => {
              if (ys === 'total') {
                // skip
              } else if (ys === 'avg') {
                let avgData = data[studyItem][ys][week];
                dataPartiAvgs[studyItem].push(((avgData.avg / avgData.total) * 100) || 0); // 완료율 학습자평균
                dataTimeAvgs[studyItem].push(avgData.timeavg || 0); // 접속시간 학습자평균
              } else {
                let weekData = data[studyItem][ys][week];
                dataPartis[studyItem][ys].push(((weekData.done / weekData.total) * 100) || 0); // 완료율
                if (studyItem === "vod") {
                  dataTimes[studyItem][ys].push(weekData.time || 0); // 접속시간
                }
                dataTotals[studyItem][ys].todo += weekData.todo;
                dataTotals[studyItem][ys].done += weekData.done;
                dataTotals[studyItem][ys].total += weekData.total;
              }
            });
          });
        }
        let chartData = Object.keys(data).map((studyItem) => {
          return {
            studyItem: studyItem,
            totals: dataTotals[studyItem],
            partis: dataPartis[studyItem],
            times: dataTimes[studyItem],
            partiAvgs: dataPartiAvgs[studyItem],
            timeAvgs: dataTimeAvgs[studyItem],
          }
        });
        chartData.forEach((row) => {
          let datasetTotal = [{
            label: this.$i18n.translate('완료'),
            data: []
          }, {
            label: this.$i18n.translate('미완료'),
            data: []
          }, ];
          let ysLabels = [];
          Object.entries(row.totals).forEach((p) => {
            if (p[1].total > 0) {
              let v = p[0].split('-');
              ysLabels.push(this.$i18n.translate(`{0}년도{1}`, v[0], SEMESTERS[v[1]]));
              datasetTotal[0].data.push(p[1].done);
              datasetTotal[1].data.push(p[1].todo);
            }
          });
          datasetTotal = datasetTotal.map((row, i) => {
            row.backgroundColor = this.dataColor(i);
            row.barThickness = 15;
            return row;
          });
          this.legendTotals = datasetTotal.map((row) => {
            return {
              label: row.label,
              style: `background-color:${row.backgroundColor}`
            }
          });
          if (ysLabels.length > 0) {
            this.totalChartData.push({
              title: STUDY_ITEMS[row.studyItem],
              // labels: ysLabels,
              labels: [' '],
              datasets: datasetTotal
            });
          }

          let datasetParti = [];
          this.legendPartis = [];
          Object.entries(row.partis).forEach((p) => {
            // let v = p[0].split('-');
            datasetParti.push({
              // label: `${v[0]}년도 ${SEMESTERS[v[1]]}`,
              label: this.$i18n.translate(`완료율`),
              data: p[1]
            });
          });
          datasetParti.push({
            label: this.$i18n.translate('학습자평균'),
            data: row.partiAvgs
          });
          datasetParti = datasetParti.map((row, i) => {
            row.backgroundColor = this.dataColor(i);
            row.borderColor = this.dataColor(i);
            return row;
          });
          this.legendPartis = datasetParti.map((row) => {
            return {
              label: row.label,
              style: `background-color:${row.backgroundColor}`
            }
          });
          this.partiChartData.push({
            title: STUDY_ITEMS[row.studyItem],
            unitY: '%',
            labels: weekLabels,
            datasets: datasetParti
          });

          let datasetTime = [];
          let existTimeData = false;
          if (row.times) {
            Object.entries(row.times).forEach((p) => {
              // let v = p[0].split('-');
              datasetTime.push({
                // label: `${v[0]}년도 ${SEMESTERS[v[1]]}`,
                label: this.$i18n.translate(`접속시간(분)`),
                data: p[1]
              });
              existTimeData = true;
            });
          }
          if (existTimeData) {
            datasetTime.push({
              label: this.$i18n.translate('학습자평균(분)'),
              data: row.timeAvgs
            });
            datasetTime = datasetTime.map((row, i) => {
              row.backgroundColor = this.dataColor(i);
              row.borderColor = this.dataColor(i);
              return row;
            });
            this.legendTimes = datasetTime.map((row) => {
              return {
                label: row.label,
                style: `background-color:${row.backgroundColor}`
              }
            });
            this.timeChartData.push({
              title: STUDY_ITEMS[row.studyItem],
              unitY: this.$i18n.translate('분'),
              labels: weekLabels,
              datasets: datasetTime
            });
          }
        });

        this.sortData(this.totalChartData);
        this.sortData(this.partiChartData);
        this.sortData(this.timeChartData);
      }
    },
  }
}
</script>
